// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as Services from '@/data/services.js'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'web-animations-js'

Vue.component('vue-draggable-resizable', VueDraggableResizable)
// import './assets/css/main.css'
// import '../static/jot.css'

Vue.config.productionTip = false

let el = document.createElement('div')
el.setAttribute('id', 'vessel-script')

if (!window.VESSEL_SCRIPT_LOADED) {
  window.VESSEL_SCRIPT_LOADED = true
  Services.init().then((api) => {
    Vue.prototype.$server = api
    /* eslint-disable no-new */
    let app = new Vue({
      el,
      router,
      components: { App },
      template: '<App/>'
    })

    let menu = document.querySelector('.sticky-placeholder')
    if (menu) {
      menu.parentNode.insertBefore(app.$el, menu.nextSibling)
    } else {
      document.body.append(app.$el)
    }

    app.$el.style.cssText = `
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: 999999;
    `

    // let footer = document.querySelector('.droopmenu-navbar')
    // if (footer) {
    //   // let rect = footer.getBoundingClientRect()
    //   // let padding = (window.innerHeight - rect.height)
    //   // padding = (padding > 0 ? padding : 0)
    //   // app.$el.style.height = padding + 'px'
    // }

    // scan clean div
    let tryCount = 10000
    let tryMove = setInterval(() => {
      let attach = document.querySelector('.auto-padding-div')
      if (attach) {
        attach.parentNode.removeChild(attach)
        window.dispatchEvent(new Event('resize'))
        clearInterval(tryMove)
      } else {
        tryCount--
        if (tryCount <= 0) {
          clearInterval(tryMove)
        }
      }
    }, 100)
  })

  // /* eslint-disable no-new */
  // new Vue({
  //   el,
  //   router,
  //   components: { App },
  //   template: '<App/>'
  // })
}



// WEBPACK FOOTER //
// ./src/main.js